import axios from "axios";
import {
  CarteImageFailure,
  CarteImageStart,
  CarteImageSuccess,
  getInfopersonFailure,
  getInfopersonStart,
  getInfopersonSuccess,
  updateInfopersonFailure,
  updateInfopersonStart,
  updateInfopersonSuccess,
} from "./InfopersonActions";
import { API_URL } from "../../config/runtimeConfig";

const axiosInstance = axios.create({
  baseURL: API_URL,
});

export const getInfoperson = async (dispatch) => {
  dispatch(getInfopersonStart());
  try {
    const res = await axiosInstance.get(`/user/infoperson`, {
      headers: {
        token:
          `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
      },
    });
    dispatch(getInfopersonSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(getInfopersonFailure(err.response.data.message));
    } else {
      dispatch(getInfopersonFailure("Unkown Error"));
    }
  }
};

export const deleteCarteImage = async (dispatch) => {
  dispatch(CarteImageStart());
  try {
    const res = await axiosInstance.get(`/user/infoperson/carte/delete`, {
      headers: {
        token:
          `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
      },
    });
    dispatch(CarteImageSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(CarteImageFailure(err.response.data.message));
    } else {
      dispatch(CarteImageFailure("Unkown Error"));
    }
  }
};

export const updateInfoperson = async (
  dispatch,
  nom,
  tel1,
  tel2,
  email,
  wilaya,
  commune,
  carteNumero,
  file,
) => {
  dispatch(updateInfopersonStart());
  let reqBody = { nom, tel1, tel2, email, wilaya, commune, carteNumero };
  /** Begin Upload File **/
  if (file) {
    const data = new FormData();
    const fileName = Date.now() + file.name;
    data.append("name", fileName);
    data.append("file", file);
    reqBody.carteFile = fileName;
    try {
      await axiosInstance.post("/uploadCarte", data);
    } catch (err) {
      if (err.response) {
        dispatch(updateInfopersonFailure(err.response.data.message));
      } else {
        dispatch(updateInfopersonFailure("Unkown Error"));
      }
    }
  }
  /** End Upload File **/
  try {
    const res = await axiosInstance.post(`/user/infoperson/update`, reqBody, {
      headers: {
        token:
          `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
      },
    });
    dispatch(updateInfopersonSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(updateInfopersonFailure(err.response.data.message));
    } else {
      dispatch(updateInfopersonFailure("Unkown Error"));
    }
  }
};
